import styles from "./StepRicerca.module.css";
import React from "react";
import Steps from "../../../utils/OggettiUtili"

export class StepRicerca extends React.Component {

    state = {
        progressBar: ""
    }

    constructor(props) {
        super(props);
        this.selectStep = this.selectStep.bind(this)
    }

    componentDidMount() {
        this.selectStep()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.pagina !== this.props.pagina) {
            this.selectStep()
        }
    }

    selectStep() {
        let ret = []
        let steps = Steps.StepReport

        let numeroStep = 1
        let i = 0
        for (let key in steps) {

            if (this.props.pagina === steps["REPORT"].codice) {
                let li =
                    <div className="d-inline-flex align-items-center">
                        <div className={styles.active.concat(" " + styles.pallino + " d-inline-block")}>
                            {steps[key].codice == "CRITERI_SELEZIONE" ?
                                <p className={styles.testoPallino}>{<span>&#10003;</span>}</p>
                                : <p className={styles.testoPallino}>{numeroStep}</p>}
                        </div>
                        <div className={styles.testo.concat(" d-inline-block ")}>{steps[key].descrizione}</div>
                    </div>
                ret.push(li)
            } else if (this.props.pagina === key) {
                let li =
                    <div className="d-inline-flex align-items-center">
                        <div className={styles.active.concat(" " + styles.pallino + " d-inline-block")}>
                            <p className={styles.testoPallino}>{numeroStep}</p>
                        </div>
                        <div className={styles.testo.concat(" d-inline-block ")}>{steps[key].descrizione}</div>
                    </div>
                ret.push(li)
            } else {
                let li =
                    <div className="d-inline-flex align-items-center">
                        <div className={styles.pallino.concat(" d-inline-block")}>{numeroStep}</div>
                        <div className={styles.testo.concat(" d-inline-block ")}>{steps[key].descrizione}</div>
                    </div>
                ret.push(li)
            }
            numeroStep++
            i++
        }

        return this.setState({progressBar: ret})
    }

    render() {
        return (
            <div className={styles.container}>
                <ul className={styles.progressbar}>
                    {this.state.progressBar}
                </ul>
            </div>
        );
    }
}

